import { Button, Card, Tooltip } from 'antd';
import { SettingOutlined, DeleteOutlined } from '@ant-design/icons';
import { PhoneOutlined, SoundOutlined } from '@ant-design/icons';

interface UnconfiguredAgentCardProps {
	type: 'inbound' | 'outbound';
	index: number;
	onConfigure: () => void;
	onDelete: () => void;
	loading?: boolean;
	disabled?: boolean;
}

const UnconfiguredAgentCard: React.FC<UnconfiguredAgentCardProps> = ({
	type,
	index,
	onConfigure,
	onDelete,
	loading = false,
	disabled = false,
}) => {
	const icon = type === 'inbound' ? <PhoneOutlined /> : <SoundOutlined />;
	const typeName = type === 'inbound' ? 'Inbound' : 'Outbound';

	return (
		<Card className="agent-card">
			<div className="flex items-center justify-between">
				<div className="flex items-center gap-4">
					<div className="flex items-center justify-center w-9 h-9 rounded-lg text-base bg-gray-50 text-gray-600">
						{icon}
					</div>
					<div>
						<div className="font-medium text-gray-800">
							{typeName} Agent Slot ({index + 1})
						</div>
						<div className="text-sm text-gray-500">Not configured</div>
					</div>
				</div>
				<div className="flex items-center gap-2">
					<Button
						type="primary"
						icon={<SettingOutlined />}
						onClick={onConfigure}
						disabled={disabled}
					>
						Configure
					</Button>
					<Tooltip title="Delete Agent">
						<Button
							type="text"
							danger
							icon={<DeleteOutlined />}
							loading={loading}
							onClick={onDelete}
							disabled={disabled}
						/>
					</Tooltip>
				</div>
			</div>
		</Card>
	);
};

export default UnconfiguredAgentCard;
